// ============ DOCTOR INFO ============
export const DOCTOR = {
  name: "Dr. César S. Martínez Maldonado",
  shortName: "Dr. César Martínez",
  title: "Psiquiatra · Neurología",
  subtitle: "Atención Médica Integral en Psiquiatría y Neurología",
  yearsExperience: 40,
  phone: "228 814 74 68",
  mobile: "228 826 59 29",
  whatsapp: "228 826 59 29",
  phoneMartinez: "232 32 48163",
  email: "dr-cesarsmartinezmaldonado@hotmail.com",
  location: "Xalapa, Veracruz · México",
  address: "Zacatecas No. 100, Esq. Morelia, Col. Progreso, Xalapa de Equez, Veracruz",
  addressMartinez: "Hospital Ángel, Martinez de la Torre, Veracruz",
  facebook: "https://www.facebook.com/drcesars",
  twitter: "https://twitter.com/dr_cesars",
  photo: "https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=800&auto=format&fit=crop",
  heroImage: "https://images.unsplash.com/photo-1631962757827-de7bab7a48f8?w=1400&auto=format&fit=crop",
  officeImage: "https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w=1200&auto=format&fit=crop",
};

// ============ SPECIALTIES (9 áreas clínicas) ============
export const SPECIALTIES = [
  {
    slug: "demencias",
    title: "Demencias",
    emoji: "🧠",
    short: "Alzheimer y otros deterioros cognitivos",
    image: "https://images.unsplash.com/photo-1584515933487-779824d29309?w=1000&auto=format&fit=crop",
    description: "Las demencias son trastornos neurodegenerativos que afectan la memoria, el pensamiento, el comportamiento y la capacidad de realizar actividades cotidianas. La enfermedad de Alzheimer es la causa más frecuente.",
    symptoms: [
      "Pérdida progresiva de memoria",
      "Desorientación en tiempo y espacio",
      "Dificultades de lenguaje y comprensión",
      "Cambios de personalidad y conducta",
      "Dificultad para actividades diarias",
      "Alteraciones del sueño",
    ],
    treatment: "Evaluación neuropsiquiátrica integral, manejo farmacológico con inhibidores de la colinesterasa y memantina, psicoeducación familiar, intervenciones no farmacológicas para estimulación cognitiva y soporte a los cuidadores principales.",
  },
  {
    slug: "neurologicos",
    title: "Trastornos Neurológicos",
    emoji: "⚡",
    short: "Epilepsia, parálisis, ECV, trastornos del sueño",
    image: "https://images.unsplash.com/photo-1761637755331-562c6529ace6?w=1000&auto=format&fit=crop",
    description: "Conjunto de enfermedades que afectan al sistema nervioso central y periférico. Incluyen epilepsia, enfermedades cerebrovasculares, trastornos del movimiento, neuropatías y enfermedades desmielinizantes.",
    symptoms: [
      "Crisis convulsivas",
      "Débilidad o parálisis",
      "Movimientos involuntarios (temblor, tics)",
      "Alteraciones del equilibrio y la marcha",
      "Pérdida de sensibilidad u hormigueo",
      "Trastornos del sueño severos",
    ],
    treatment: "Estudio clínico exhaustivo con apoyo de electroencefalograma, resonancia magnética y estudios neuropsicológicos cuando se requiere. Manejo con anticonvulsivos, neuroprotectores y terapia de rehabilitación multidisciplinaria.",
  },
  {
    slug: "cefaleas",
    title: "Cefaleas y Migrañas",
    emoji: "🧩",
    short: "Dolor de cabeza crónico y migraña",
    image: "https://images.unsplash.com/photo-1631963137006-7c6d5f103ba2?w=1000&auto=format&fit=crop",
    description: "Dolores de cabeza primarios (migraña, tensional, en racimos) y secundarios a otras enfermedades. Pueden ser incapacitantes y afectar gravemente la calidad de vida.",
    symptoms: [
      "Dolor pulsatil o presivo de cabeza",
      "Aura visual (luces, destellos)",
      "Náuseas y vómito",
      "Fotofobia y fonofobia",
      "Dolor recurrente o persistente",
      "Mareo y vértigo asociados",
    ],
    treatment: "Identificación de detonantes personales, tratamiento agudo con analgésicos y triptanos, profilaxis con betabloqueadores, topiramato y antidepresivos a dosis bajas. Psicoeducación sobre estilo de vida, sueño e hidratación.",
  },
  {
    slug: "esquizofrenia",
    title: "Esquizofrenia",
    emoji: "🔮",
    short: "Trastornos psicóticos y del pensamiento",
    image: "https://images.unsplash.com/photo-1765447551792-1c9691db3ea2?w=1000&auto=format&fit=crop",
    description: "Trastorno mental crónico y grave que afecta la forma de pensar, sentir y comportarse. Se caracteriza por la presencia de síntomas positivos (alucinaciones, delirios), negativos (apatía, aislamiento) y cognitivos.",
    symptoms: [
      "Alucinaciones auditivas o visuales",
      "Ideas delirantes (persecución, referencia)",
      "Pensamiento desorganizado",
      "Aislamiento social y afectivo",
      "Descuido de la higiene personal",
      "Deterioro funcional progresivo",
    ],
    treatment: "Tratamiento con antipsicóticos de segunda generación, rehabilitación psicosocial, terapia familiar, estrategias de adherencia y seguimiento continuo. Control de efectos adversos y comorbilidades metabólicas.",
  },
  {
    slug: "afectivos",
    title: "Trastornos Afectivos",
    emoji: "💙",
    short: "Depresión, trastorno bipolar, distimia",
    image: "https://images.unsplash.com/photo-1551847677-dc82d764e1eb?w=1000&auto=format&fit=crop",
    description: "Engloban la depresión mayor, el trastorno bipolar y la distimia. Son enfermedades médicas reales, con base biológica en la disfunción de neurotransmisores, que requieren tratamiento especializado.",
    symptoms: [
      "Tristeza profunda y persistente",
      "Pérdida de interés o placer",
      "Fatiga y baja energía",
      "Alteraciones del sueño y el apetito",
      "Sentimientos de culpa o inutilidad",
      "Ideación suicida en casos graves",
      "Episodios de euforia o manía (bipolar)",
    ],
    treatment: "Evaluación exhaustiva para diagnóstico diferencial. Antidepresivos ISRS/IRSN, estabilizadores del ánimo, psicoterapia cognitivo-conductual, activación conductual y seguimiento cercano. En casos severos, hospitalización parcial o total.",
  },
  {
    slug: "ansiedad",
    title: "Ansiedad",
    emoji: "🌿",
    short: "Crisis de pánico, fobias, TOC, TEPT",
    image: "https://images.pexels.com/photos/5928615/pexels-photo-5928615.jpeg?auto=compress&cs=tinysrgb&w=1000",
    description: "Trastornos de ansiedad generalizada, crisis de pánico, fobias, trastorno obsesivo-compulsivo y estrés postraumático. Son los trastornos mentales más prevalentes y responden excelentemente al tratamiento integral.",
    symptoms: [
      "Preocupación excesiva e incontrolable",
      "Taquicardia, sudoración, temblor",
      "Sensación de ahogo o mareo",
      "Miedo intenso injustificado",
      "Pensamientos obsesivos",
      "Evitación de situaciones",
      "Insomnio y tensión muscular",
    ],
    treatment: "Combinación de psicoterapia cognitivo-conductual con técnicas de exposición, mindfulness, entrenamiento en respiración. Manejo farmacológico con ISRS o IRSN. Tratamiento puntual con ansiolíticos solo en casos específicos y por tiempo limitado.",
  },
  {
    slug: "trastornos-conductuales",
    title: "Trastornos Conductuales",
    emoji: "👨‍👩‍👧",
    short: "TDAH, autismo, conducta en niños y adolescentes",
    image: "https://images.unsplash.com/photo-1654613698246-b6d44aef0fd5?w=1000&auto=format&fit=crop",
    description: "TDAH, trastornos del espectro autista, trastorno oposicionista desafiante y trastornos de conducta en niños y adolescentes. Requieren abordaje integral con la familia y la escuela.",
    symptoms: [
      "Inatención y distracción fácil",
      "Hiperactividad e impulsividad",
      "Desafío constante a la autoridad",
      "Agresividad o retraimiento",
      "Bajo rendimiento escolar",
      "Dificultad en relaciones sociales",
    ],
    treatment: "Evaluación neuropsiquiátrica infantil, psicoterapia conductual y familiar, orientación a padres y docentes, manejo farmacológico cuando se requiere (metilfenidato, atomoxetina), intervención temprana y multidisciplinaria.",
  },
  {
    slug: "trastornos-conductuales-ii",
    title: "Trastornos Conductuales II",
    emoji: "👥",
    short: "Trastornos de personalidad y del adulto",
    image: "https://images.unsplash.com/photo-1511632765486-a01980e01a18?w=1000&auto=format&fit=crop",
    description: "Trastornos de personalidad (límite, antisocial, evitativo, obsesivo, narcisista) y otros trastornos del comportamiento del adulto que afectan significativamente la vida personal, social y laboral.",
    symptoms: [
      "Patrones persistentes de conducta",
      "Relaciones interpersonales inestables",
      "Autoimagen alterada",
      "Impulsividad y conductas de riesgo",
      "Dificultad para la empatía",
      "Conflictos familiares y laborales recurrentes",
    ],
    treatment: "Psicoterapia especializada de larga duración (dialéctico-conductual, esquemas, mentalización), manejo psicofarmacológico de síntomas centrales, contención familiar, prevención de auto-agresiones y crisis.",
  },
  {
    slug: "adicciones",
    title: "Adicciones",
    emoji: "🤝",
    short: "Alcoholismo y fármaco dependencias",
    image: "https://images.unsplash.com/photo-1765896387454-3c29c0473615?w=1000&auto=format&fit=crop",
    description: "Tratamiento integral del alcoholismo y fármaco dependencias. El Dr. Martínez es Diplomado y Especialista en el Tratamiento Integral del Alcoholismo y las Fármaco Dependencias.",
    symptoms: [
      "Consumo compulsivo e incontrolable",
      "Tolerancia creciente",
      "Síndrome de abstinencia",
      "Pérdida de relaciones y trabajo",
      "Negación del problema",
      "Deterioro físico y mental",
    ],
    treatment: "Desintoxicación médica supervisada, manejo de síndrome de abstinencia, farmacoterapia anti-craving (naltrexona, acamprosato), psicoterapia individual y grupal, integración a grupos de autoayuda, prevención de recaídas y rehabilitación.",
  },
];

// ============ ARTÍCULOS / VIDEOS destacados ============
export const ARTICLES = [
  {
    slug: "depresion-neurotransmisores-1",
    title: "Disfunción de los Neurotransmisores en la Depresión I",
    category: "Depresión",
    image: "https://images.unsplash.com/photo-1631962757827-de7bab7a48f8?w=1200&auto=format&fit=crop",
    excerpt: "La depresión no es solo 'estar triste'. Es una enfermedad con base biológica en los neurotransmisores del cerebro.",
    content: [
      "La depresión mayor es una enfermedad médica real con base neuroquímica. Los principales neurotransmisores implicados son la serotonina, la noradrenalina y la dopamina.",
      "En la depresión se observa un desequilibrio en la síntesis, liberación y recaptura de estos neurotransmisores en las sinapsis cerebrales. Este desequilibrio afecta circuitos específicos del sistema límbico y la corteza prefrontal.",
      "Entender este mecanismo permite explicar cómo los antidepresivos modernos (ISRS, IRSN, atipicos) restauran el equilibrio neuroquímico, con resultados progresivos a lo largo de 4 a 8 semanas de tratamiento continuo.",
    ],
  },
  {
    slug: "depresion-neurotransmisores-2",
    title: "Disfunción de los Neurotransmisores en la Depresión II",
    category: "Depresión",
    image: "https://images.unsplash.com/photo-1608183230429-7a3580b16d31?w=1200&auto=format&fit=crop",
    excerpt: "Profundizando en la neurobiología de la depresión: circuitos cerebrales implicados.",
    content: [
      "En la segunda parte exploramos los circuitos cerebrales específicos afectados: la amigdala (miedo y respuesta emocional), el hipocampo (memoria y estrés) y la corteza prefrontal dorsolateral (regulación cognitiva).",
      "La hiperactividad del eje hipotálamo-hipófisis-adrenal con exceso de cortisol sostenido produce cambios estructurales y funcionales. Esto explica la relación entre el estrés crónico y el desarrollo de depresión.",
      "Los estudios de neuroimagen han demostrado que el tratamiento antidepresivo puede revertir parcialmente estos cambios, especialmente cuando se combina con psicoterapia.",
    ],
  },
  {
    slug: "depresion-neurotransmisores-3",
    title: "Disfunción de los Neurotransmisores en la Depresión III",
    category: "Depresión",
    image: "https://images.unsplash.com/photo-1765447551792-1c9691db3ea2?w=1200&auto=format&fit=crop",
    excerpt: "El papel de la neurogénesis y la plasticidad sináptica en la recuperación.",
    content: [
      "Investigaciones recientes han revelado que la depresión también implica alteraciones en la neurogénesis del hipocampo y la plasticidad sináptica.",
      "Los antidepresivos modernos promueven la síntesis de factores neurotróficos como el BDNF (Brain-Derived Neurotrophic Factor), esenciales para formar nuevas conexiones neuronales.",
      "Esto fundamenta por qué el tratamiento requiere tiempo: los cambios bioquímicos son rápidos pero los cambios estructurales beneficiosos requieren semanas a meses.",
    ],
  },
  {
    slug: "depresion-neurotransmisores-4",
    title: "Beneficios del Tratamiento Antidepresivo",
    category: "Depresión",
    image: "https://images.unsplash.com/photo-1572373785011-af1fe5216e15?w=1200&auto=format&fit=crop",
    excerpt: "Beneficios comprobados del tratamiento integral contra la depresión.",
    content: [
      "El tratamiento oportuno de la depresión previene las complicaciones como el suicidio, cronificación, deterioro funcional y desarrollo de otros trastornos comorbidos.",
      "Además de la remisión de síntomas, el tratamiento integral (farmacológico + psicoterapéutico) restaura la funcionalidad, mejora las relaciones familiares y laborales, y aumenta la calidad de vida.",
      "La tasa de respuesta al tratamiento inicial es del 60-70%. Con ajustes adecuados y adherencia, más del 85% de pacientes alcanzan remisión.",
    ],
  },
  {
    slug: "depresion-neurotransmisores-5",
    title: "Disfunción de los Neurotransmisores en la Depresión V",
    category: "Depresión",
    image: "https://images.unsplash.com/photo-1631963137006-7c6d5f103ba2?w=1200&auto=format&fit=crop",
    excerpt: "Nuevas terapias y abordajes emergentes en el tratamiento de la depresión.",
    content: [
      "Nuevos tratamientos como la estimulación magnética transcraneal (EMT), ketamina y esketamina intranasal abren opciones para depresiones resistentes.",
      "La psicoterapia basada en evidencia (cognitivo-conductual, interpersonal, activación conductual) es un pilar fundamental y no un complemento opcional.",
      "La prevención de recaídas requiere mantener el tratamiento al menos 6-12 meses después de la remisión, y en casos recurrentes, de forma indefinida.",
    ],
  },
  {
    slug: "mecanismos-antidepresivos",
    title: "Mecanismos Antidepresivos",
    category: "Depresión",
    image: "https://images.unsplash.com/photo-1761637755331-562c6529ace6?w=1200&auto=format&fit=crop",
    excerpt: "Un repaso claro por los mecanismos de acción de los principales antidepresivos modernos.",
    content: [
      "Los ISRS (inhibidores selectivos de la recaptura de serotonina) son primera línea: fluoxetina, sertralina, escitalopram, paroxetina, citalopram.",
      "Los IRSN (duloxetina, venlafaxina) actúan sobre serotonina y noradrenalina, útiles en depresión con fatiga marcada o dolor crónico.",
      "Los atipicos (mirtazapina, bupropión, vortioxetina) tienen mecanismos únicos que permiten elegir según el perfil del paciente y efectos adversos.",
    ],
  },
  {
    slug: "tda-h",
    title: "TDA-H · Trastorno por Déficit de Atención",
    category: "TDAH",
    image: "https://images.unsplash.com/photo-1654613698246-b6d44aef0fd5?w=1200&auto=format&fit=crop",
    excerpt: "Trastorno por Déficit de Atención con o sin Hiperactividad: diagnóstico y abordaje integral.",
    content: [
      "El TDAH es un trastorno del neurodesarrollo que afecta al 5-7% de niños y persiste hasta la adultez en 60% de los casos.",
      "Se caracteriza por tres núcleos sintomáticos: inatención, hiperactividad e impulsividad, con consecuencias académicas, laborales y sociales importantes.",
      "El tratamiento combina psicoestimulantes (metilfenidato, lisdexanfetamina) o no-estimulantes (atomoxetina), con intervenciones conductuales, orientación a padres y adecuaciones escolares.",
    ],
  },
  {
    slug: "nutricion-esquizofrenia",
    title: "Nutrición Saludable para el Paciente con Esquizofrenia",
    category: "Esquizofrenia",
    image: "https://images.pexels.com/photos/5928615/pexels-photo-5928615.jpeg?auto=compress&cs=tinysrgb&w=1200",
    excerpt: "La nutrición como pilar del tratamiento integral del paciente con esquizofrenia.",
    content: [
      "Los pacientes con esquizofrenia presentan mayor riesgo cardiovascular y metabólico, agravado por algunos antipsicóticos.",
      "Una dieta rica en omega-3, antioxidantes, vitaminas del grupo B y baja en azúcares refinados apoya el tratamiento farmacológico.",
      "Promover actividad física regular, control del peso y evitar tabaco y sustancias son parte fundamental del tratamiento integral.",
    ],
  },
  {
    slug: "redes-neuronales",
    title: "Redes Neuronales",
    category: "Neurociencia",
    image: "https://images.unsplash.com/photo-1765447551792-1c9691db3ea2?w=1200&auto=format&fit=crop",
    excerpt: "Una introducción a cómo las redes neuronales cerebrales explican la conducta humana.",
    content: [
      "El cerebro humano contiene aproximadamente 86 mil millones de neuronas interconectadas en redes dedicadas.",
      "Redes como la red por defecto, red de control ejecutivo y red de saliencia se activan en distintos estados mentales y su disfunción se asocia a diversos trastornos.",
      "Comprender estas redes permite diseñar tratamientos más dirigidos y personalizados, combinando farmacología, psicoterapia y técnicas como la neuroestimulación.",
    ],
  },
  {
    slug: "alucinaciones",
    title: "Alucinaciones · Cortometraje Educativo",
    category: "Psicosis",
    image: "https://images.unsplash.com/photo-1631963137006-7c6d5f103ba2?w=1200&auto=format&fit=crop",
    excerpt: "Una mirada compasiva y educativa al fenómeno de las alucinaciones en trastornos psicóticos.",
    content: [
      "Las alucinaciones son percepciones reales sin estímulo externo. Las más frecuentes son auditivas, seguidas de visuales.",
      "Para el paciente son experiencias auténticas e intensas. El papel de la familia es clave para no confrontar directamente pero sí facilitar el tratamiento médico.",
      "Con antipsicóticos adecuados y constancia, la mayoría de los pacientes reduce significativamente las alucinaciones y recupera funcionalidad.",
    ],
  },
  {
    slug: "no-hacer-dano",
    title: "No Hacer Daño · Cortometraje",
    category: "Ética médica",
    image: "https://images.unsplash.com/photo-1580869318757-a6c605b061ed?w=1200&auto=format&fit=crop",
    excerpt: "Primum non nocere: el principio ético más importante en medicina.",
    content: [
      "'Primum non nocere' - 'Primero no hacer daño' (Hipócrates, 345 a.C.) es el principio ético fundamental de la medicina.",
      "Cada decisión terapéutica debe sopesar beneficios y riesgos, con el paciente informado y participando en la decisión.",
      "En psiquiatría esto implica usar los medicamentos estrictamente necesarios, a dosis mínimas efectivas y por el tiempo necesario, siempre vigilando efectos adversos.",
    ],
  },
];

// ============ TESTIMONIOS ============
export const TESTIMONIOS = [
  {
    name: "María L.",
    role: "Paciente, Xalapa",
    text: "Después de años sufriendo depresión, encontré al Dr. César y mi vida cambió. Su trato humano, profesional y respetuoso marcó la diferencia. Hoy tengo una vida plena.",
    rating: 5,
  },
  {
    name: "Roberto G.",
    role: "Familiar de paciente",
    text: "Mi madre tiene Alzheimer. El Dr. Martínez no solo la atendió a ella, también nos capacitó a toda la familia para cuidarla con amor y conocimiento.",
    rating: 5,
  },
  {
    name: "Alejandra V.",
    role: "Paciente, Martinez de la Torre",
    text: "La ansiedad me impidió vivir por mucho tiempo. El tratamiento con el Dr. César, combinando medicamento y psicoterapia, me devolvió mi libertad.",
    rating: 5,
  },
  {
    name: "José A.",
    role: "Padre de paciente con TDAH",
    text: "Mi hijo mejoró muchísimo en la escuela y en casa. El Doctor nos dio herramientas y explicó todo de manera clara. Nunca nos sentimos juzgados.",
    rating: 5,
  },
  {
    name: "Lucía M.",
    role: "Paciente recuperada",
    text: "40 años de experiencia se notan. Su diagnóstico fue certero después de que otros médicos fallaron. Su trato es cercano y siempre disponible.",
    rating: 5,
  },
  {
    name: "Fernando R.",
    role: "Paciente con adicciones",
    text: "Salí del alcoholismo con su acompañamiento. Fue firme pero siempre respetuoso. Me ayudó a reconstruir mi vida y mis relaciones familiares.",
    rating: 5,
  },
];

// ============ ENLACES RECOMENDADOS ============
export const LINKS = [
  { name: "Asociación Psiquiátrica Mexicana", url: "https://psiquiatrasapm.org.mx/", description: "APM A.C. - Colegio de Psiquiatras de México" },
  { name: "Organización Mundial de la Salud - Salud Mental", url: "https://www.who.int/es/health-topics/mental-health", description: "Información oficial sobre salud mental global" },
  { name: "Instituto Nacional de Psiquiatría RFM", url: "https://www.inprf.gob.mx/", description: "Investigación y atención especializada en México" },
  { name: "CONADIC - Adicciones", url: "https://www.gob.mx/salud/conadic", description: "Comisión Nacional contra las Adicciones" },
  { name: "Alzheimer's Association México", url: "https://www.alz.org/es-mx", description: "Apoyo a familiares de pacientes con demencia" },
  { name: "Sociedad Mexicana de Neurología", url: "https://smnconference.com", description: "Neurología académica en México" },
];

// ============ DATO DE LA SEMANA ============
export const DATO_SEMANA = {
  title: "¿Sabías que la depresión es tratable?",
  subtitle: "Un dato que puede cambiar vidas",
  date: new Date().toLocaleDateString("es-MX", { year: "numeric", month: "long", day: "numeric" }),
  image: "https://images.unsplash.com/photo-1608183230429-7a3580b16d31?w=1400&auto=format&fit=crop",
  content: [
    "Según la OMS, más de 280 millones de personas en el mundo padecen depresión, pero más del 75% en países de ingresos bajos y medios no recibe tratamiento.",
    "La depresión NO es un signo de debilidad ni 'falta de carácter'. Es una enfermedad médica real con base biológica, tan real como la diabetes o la hipertensión.",
    "Con tratamiento adecuado (farmacológico + psicoterapéutico), más del 80% de pacientes mejora significativamente. La clave es buscar ayuda especializada a tiempo.",
    "Si tú o algúen cercano presenta síntomas de tristeza persistente, pérdida de interés, cambios en sueño o apetito por más de dos semanas, consulta con un profesional.",
  ],
};
